module.exports = __webpack_public_path__ + "img/propertylist1.e3ee97a6.png";